module.exports = __webpack_public_path__ + "img/5.32de576f.png";